import { requests } from '../../api/services';
import { BaseModel } from '../../model/shared/BaseModel';
import { COMPANY_URL } from '../../utils/Endpoints';
import {Company, CompanyBrandAclRequest, CompanyBrandAclResponse} from '../../model/company/Company';
import { IUser } from '../../model/user/IUser';

export const CompanyService = {
    getCompanies: (params: any): Promise<BaseModel<Company>> => requests.get(`${COMPANY_URL}`, params),
    getCompany: (id: number): Promise<Company> => requests.get(`${COMPANY_URL}/${id}`),
    getCompanyUsers: (id: number, params?: any): Promise<IUser[]> => requests.get(`${COMPANY_URL}/${id}/users`, params),
    getCompanyPartners: (params: any): Promise<{ data: Company[] }> =>
        requests.get(`${COMPANY_URL}/partners/companies`, params),
    postCompanyPartner: (params: any): Promise<IUser[]> => requests.post(`${COMPANY_URL}/partners/assign`, params),
    getCompanyPartnersAssigned: (params: any): Promise<{ data: Company[] }> =>
        requests.get(`${COMPANY_URL}/partners/shared`, params),
    deleteCompanyPartner: (clientId: number, supplierId: number): Promise<Company[]> =>
        requests.delete(`${COMPANY_URL}/partners/client/${clientId}/supplier/${supplierId}`),
    deleteCompany: (id: number): Promise<Company[]> => requests.delete(`${COMPANY_URL}/${id}`),
    toggleClientLight: (id: number, params?: any): Promise<Company[]> =>
        requests.put(`${COMPANY_URL}/partners/toggle/light/${id}`, params),
    getPartnershipCompanies: (params: any): Promise<{ data: Company[] }> =>
        requests.get(`${COMPANY_URL}/dropdown/partnership`, params),

    // Groups
    getCompanyGroups: (clientId: number, params?: any): Promise<any> =>
        requests.get(`${COMPANY_URL}/groups/client/${clientId}`, params),
    createGroup: (clientId: number, body: any): Promise<any> =>
        requests.post(`${COMPANY_URL}/groups/client/${clientId}`, body),
    updateGroup: (groupId: number, body: any): Promise<any> => requests.put(`${COMPANY_URL}/groups/${groupId}`, body),
    deleteGroup: (groupId: number): Promise<any> => requests.delete(`${COMPANY_URL}/groups/${groupId}`),
    getClientSuppliers: (clientId: number): Promise<{ data: Company[] }> =>
        requests.get(`${COMPANY_URL}/partners/shared`, { companyId: clientId, type: 'client', perPage: 100 }),

    // Group options
    createGroupOption: (groupId: number, body: any): Promise<any> =>
        requests.post(`${COMPANY_URL}/groups/options/${groupId}`, body),
    updateGroupOption: (groupId: number, optionId: number, body: any): Promise<any> =>
        requests.put(`${COMPANY_URL}/groups/group/${groupId}/options/${optionId}`, body),
    deleteGroupOption: (groupId: number, optionId: number): Promise<any> =>
        requests.delete(`${COMPANY_URL}/groups/group/${groupId}/options/${optionId}`),
    getCompanyBrandAcls: (companyId: number): Promise<CompanyBrandAclResponse[]> =>
        requests.get(`${COMPANY_URL}/brand-acls/${companyId}`),
    updateCompanyBrandAcls: (companyId: number, body: CompanyBrandAclRequest): Promise<void> =>
        requests.put(`${COMPANY_URL}/brand-acls/${companyId}`, body),

};
